import styled from 'styled-components';
// import theme from '../../../common/theme';

const ProfileStyles = styled.div``;

export default ProfileStyles;
